export default MoodColors = {
  VeryBad: "#DD5F43",
  Bad: "#E7BBB1",
  Neutral: "#EEDEB8",
  Good: "#BAE4DF",
  VeryGood: "#23D7C1",
  Unset: "#DDDAD5",
};
